import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import * as styles from "./richtext.module.css"

const RelatedBlogArticle = ({ blok }) => {
  // console.log(blok);
  const article = blok.article

  return (
    <div {...storyblokEditable(blok)} 
      id={blok._uid}
      className="leading-relaxed text-left hover:shadow-md transition-shadow"
      style={{
        marginTop: `${blok.marginTop}px`,
        marginBottom: `${blok.marginBottom}px`,
        paddingTop: `${blok.paddingTop}px`,
        paddingBottom: `${blok.paddingBottom}px`,
        borderWidth: `${blok.borderWidth}px`,
        borderColor: `${blok.borderColor?.color}`,
        backgroundColor: `${blok.bgColor?.color}`,
      }}>
        <a href={"/" + article?.full_slug} className="flex flex-col sm:flex-row">
          <img className="w-auto sm:w-[200px] h-[160px] rounded object-cover m-4" loading="lazy" 
            alt={article?.content?.image?.alt}
            src={`${article?.content?.image?.filename}/m/0x320`} />
          <div className="flex flex-col p-4">
            {blok.heading && <div className="mb-2">{blok.heading}</div>}
            <div className="font-serif font-bold my-2">{article?.content?.title}</div>
            <div className="text-sm my-4 line-clamp-3">{article?.content?.excerpt}</div>
          </div>
        </a>
    </div>
  )
}

export default RelatedBlogArticle
